const COPY_NUMBER_SUFFIX = / \((\d+)\)$/;

export function stripCopyNumberSuffix(value) {
  return String(value ?? "").trim().replace(COPY_NUMBER_SUFFIX, "");
}

export function escapeCopyRegex(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function copyNumberCodeQuery(base) {
  return { $regex: `^${escapeCopyRegex(base)} \\([0-9]+\\)$` };
}

export function nextCopyNumber(codes, base) {
  const pattern = new RegExp(
    `^${escapeCopyRegex(base)} \\((\\d+)\\)$`
  );
  let max = 0;
  for (const code of codes || []) {
    const match = String(code ?? "").match(pattern);
    if (match) max = Math.max(max, Number(match[1]));
  }
  return max + 1;
}

export function numberedCopyValue(value, n) {
  const base = stripCopyNumberSuffix(value);
  if (!base) return "";
  return `${base} (${n})`;
}

export function isDuplicateCodeError(message) {
  return /E11000|duplicate key/i.test(String(message ?? ""));
}
